import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Item } from 'my-lib-sanfelici/my-lib-sanfelici';
import { ItemsService } from 'my-lib-sanfelici';



@Component({
  selector: 'app-items-list',
  templateUrl: './items-list.component.html',
  styleUrls: ['./items-list.component.css']
})
export class ItemsListComponent implements OnInit {
items: Observable<Item[]>;
  constructor(private itemsservice: ItemsService) { }

  ngOnInit() {
    this.items = this.itemsservice.list();
  }

}
